import React, { HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Node,
} from '@uncinc/react-drupal-core';

import useClasses from '../../../../hooks/useClasses';
import { GenericViewProps } from '../..';

import './style.scss';

interface Props extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entities: GenericViewProps['entities'];
}

const ViewTipsOverview: React.FC<Props> = ({
  entities,
  className,
}) => {
  const { t } = useTranslation();
  const { buildClass, joinClasses } = useClasses('ViewTipsOverview');

  return (
    <div className={joinClasses(buildClass(), className)}>
      {entities.size > 0 && (
        <div className={buildClass('title')}>
          <h2>{t('views.tips_overview.title')}</h2>
        </div>
      )}

      <ol className={buildClass('list')}>
        {entities.map((entity) => {
          const id = entity.getIn(['nid', 0, 'value']);
          const uuid: string = entity.getIn(['uuid', 0, 'value']);
          const langcode: string = entity.getIn(['langcode', 0, 'value']);

          return (
            <Node
              key={`${uuid}:${langcode}`}
              id={id}
              entity={entity}
              viewMode="teaser"
            />
          );
        })}
      </ol>
    </div>
  );
};

export default ViewTipsOverview;
